import React from 'react';
import { isChunkError, reloadOnce } from '../lib/lazyRetry';

// Evita a "tela branca": qualquer erro ao desenhar uma tela mostra um aviso com botão para recarregar.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Erro de tela:', error, info?.componentStack);
    if (isChunkError(error)) reloadOnce();
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const stale = isChunkError(error);
    return (
      <div className="mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center gap-3 px-6 py-16 text-center" role="alert" data-testid="error-boundary">
        <h2 className="m-0 text-lg font-semibold text-[#1f284f]">
          {stale ? 'O sistema foi atualizado' : 'Algo deu errado ao abrir esta tela'}
        </h2>
        <p className="m-0 text-sm text-gray-600">
          {stale
            ? 'Há uma versão nova do FériasClube. Recarregue a página para continuar.'
            : 'Tente recarregar a página. Se o problema continuar, avise o suporte informando o que você estava fazendo.'}
        </p>
        <div className="mt-2 flex flex-wrap justify-center gap-2">
          <button type="button" onClick={() => window.location.reload()} className="rounded-full bg-[#1f284f] px-5 py-2 text-sm font-semibold text-white">
            Recarregar a página
          </button>
          <button type="button" onClick={() => { window.location.href = '/'; }} className="rounded-full border border-gray-300 px-5 py-2 text-sm font-semibold text-[#1f284f]">
            Ir para o início
          </button>
        </div>
        {!stale && error?.message ? <p className="m-0 mt-2 max-w-full break-words text-[11px] text-gray-400">{String(error.message).slice(0, 200)}</p> : null}
      </div>
    );
  }
}
